package org.hs_soft.runmynesto.data.local_datasource.menu_data


import org.hs_soft.runmynesto.domain.model.menu.MenuHeaderModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

object MenuHeaderData
{
    val data= MenuHeaderModel(
        appIcon = Res.PathIcon.logo,
        title1 =  LanguageManager.getCurrentStrings().APP_NAME_PART1 ,
        title2 = LanguageManager.getCurrentStrings().APP_NAME_PART2,
    )
}